import React, { useEffect, useState } from 'react'
import ListGroup from 'react-bootstrap/ListGroup'
import PropagateLoader from "react-spinners/PropagateLoader"
import { useDispatch, useSelector } from 'react-redux'
import { leaderBoardPointsRes, leaderBoardPointsTodo } from '../../LMS_Redux/LMS_Slices/LeaderBoard/LeaderBoardPoints'
import { useNavigate } from 'react-router-dom'

export default function LeaderBoard() {

    const [loading, setLoading] = useState(true)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const data = useSelector(state => state.leaderBoardPoints && state.leaderBoardPoints.data && state.leaderBoardPoints.data.data)
    // console.log(data)

    const userRole = JSON.parse(localStorage.getItem('user_data'));
    const role = userRole && userRole.vrole_name

    const mergedArray = data && data.userPointList && data.userPointList.map((item) => {
        const user = data && data.userList && data.userList.find((obj) => obj.vemp_code === item.user_code);
        return { ...item, user };
    })
    // console.log(mergedArray)

    const leader_board_res = () => {
        if (leaderBoardPointsRes && leaderBoardPointsRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(leaderBoardPointsTodo()).then(() => leader_board_res())
    }, [])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Leader Board </span>
                </div>

                <div className='wrapper-admin'>
                    {loading ?
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                        :
                        <ListGroup as="ol">
                            {mergedArray ?
                                mergedArray && mergedArray.map((val, index) =>
                                    <ListGroup.Item
                                        as="li"
                                        className="d-flex justify-content-between align-items-center"
                                        onClick={() => role == 'Admin' ? navigate('/user_report', { state: val.user }) : ''}
                                        style={role == 'Admin' ? { cursor: 'pointer' } : {}}
                                        key={index}
                                    >
                                        <div className="fw-bold" style={{ fontSize: '30px', color: 'rgba(34, 98, 198, 0.4)' }}>{index + 1}</div>
                                        <div className="ms-4 me-auto">
                                            <div className="fw-bold">{val && val.user && val.user.vemp_fname}</div>
                                            {val && val.user && val.user.vdepartment_name}
                                        </div>
                                        <div className="fw-bold" style={{ fontSize: '22px', color: '#2262C6' }}>{val && val.total_points}</div>
                                    </ListGroup.Item>
                                )
                                :
                                <div className='text-center mb-3'>
                                    Something went wrong can't able to load Leader Board
                                </div>
                            }
                        </ListGroup>
                    }
                </div>
            </div>
        </>
    )
}
